import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export function Layout() {
  return (
    <Box sx={{ height: "100%" }}>
      <Outlet />
    </Box>
  );
}
